import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Session, UserType, SessiebeheerResource } from '@ap/interface-apic-sessiebeheer';
import { KanaalconfiguratieBeheerResource } from '@ap/interface-apic-kanaalconfiguratie-beheer';
import { ActieveConfiguratie } from '@ap/interface-apic-kanaalconfiguratie-beheer';
import { Bank } from '@ap/interface-bspc-core';
import { ApThemeService } from '@ap/theme';

@Injectable()
export class KantoorSignService {
    public static readonly requestSession: Session = {
        authentication_level: 30
    };

    public constructor(
        private sessiebeheerResource: SessiebeheerResource,
        private route: ActivatedRoute,
        private readonly channelConfigurationResource: KanaalconfiguratieBeheerResource,
        private readonly themeService: ApThemeService
    ) {}

    public navigateToMijnKantoor(): void {
        const returnUrl = decodeURIComponent(this.route.snapshot.queryParamMap.get('returnurl') || '');
        window.location.href = `/${returnUrl}`;
    }

    public startSession(actionId: string): Observable<string | void> {
        return this.sessiebeheerResource.postSession(KantoorSignService.requestSession, {
            authenticationTaskIdHeaderParam: actionId,
            bankParam: this.getBank()
        });
    }

    public getActionId(): Observable<string | void> {
        return this.sessiebeheerResource
            .postSession(KantoorSignService.requestSession)
            .pipe(catchError((error: HttpErrorResponse) => of(error.headers ? error.headers.get('X-Authentication-Task-Id') : null)));
    }

    public isAlreadyLoggedIn(): Observable<boolean> {
        return this.sessiebeheerResource
            .getSession('0')
            .pipe(map((session: Session) => session.user && session.user.type.includes(UserType.INTERMEDIARY)));
    }

    public getBank(): Bank {
        const bank = this.themeService.getTheme();
        switch (bank) {
            case 'sns':
                return Bank.SNS;
            case 'reb':
                return Bank.RGB;
            case 'blg':
                return Bank.BLG;
            case 'asn':
                return Bank.ASN;
        }
    }

    public getActiveChannelConfiguration(bank: Bank): Observable<ActieveConfiguratie> {
        return this.channelConfigurationResource.geefActieveConfiguratie('mijn-kantoor', 'login-melding', bank);
    }
}
